module.exports = __webpack_public_path__ + "img/minus-enabled.74ce720b.png";